import { render, staticRenderFns } from "./bookBox.vue?vue&type=template&id=6687d40c&scoped=true"
import script from "./bookBox.vue?vue&type=script&lang=js"
export * from "./bookBox.vue?vue&type=script&lang=js"
import style0 from "./bookBox.vue?vue&type=style&index=0&id=6687d40c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687d40c",
  null
  
)

export default component.exports